export enum HCohorteEnum {
  SIG2504 = 'HSIG2504-FODE',
  SIG2505 = 'HSIG2505-FODE',
  SIG2507 = 'HSIG2507-FODE',
  SIG2508 = 'HSIG2508-FODE',
  MAE2509 = 'MAE2509-FODE',
  SIG2509 = 'HSIG2509-FODE',
  SIG2510 = 'HSIG2510-FODE'
}